import api from "./Api";

export interface ISaldoInicialLoteLinha {
    id: number;
    nomeArquivoOrigem: string;
    data: string | null;
    valor: number;
    contaOriginal: string | null;
    contaParticipanteOriginal: string | null;
    contaLimpaUsada: string | null;
    tipoLancamento: string | null;
    historico: string | null;
    cartaoId: number | null;
    importada: boolean;
    motivo: string | null;
    lancamentoId: number | null;
}

export interface ISaldoInicialLoteLinhaFilter {
    page?: number;
    perPage?: number;
    arquivoOperacaoId?: number;
    importada?: boolean;
    conta?: string;
    nomeArquivoOrigem?: string;
}

export interface ISaldoInicialLoteLinhaPage {
    items: ISaldoInicialLoteLinha[];
    total: number;
    page: number;
    perPage: number;
    totalPages: number;
}

export interface ISaldoInicialLoteResumo {
    arquivoOperacaoId: number;
    nomeOriginal: string;
    empresaId: number;
    empresaNome: string;
    esteiraId: number;
    esteiraPeriodoInicio: string;
    esteiraPeriodoFim: string;
    dataCadastro: string;
    dataFimProcesso: string | null;
    arquivoProcessou: boolean;
    arquivoErro: boolean;
    arquivoProcessando: boolean;
    arquivoIniciouProcesso: boolean;
    totalContasImportadas: number;
    totalContasRejeitadas: number;
    totalLinhas: number;
    totalLinhasImportadas: number;
}

class SaldoInicialLoteService {
    async listarLinhas(esteiraId: number, filter: ISaldoInicialLoteLinhaFilter): Promise<ISaldoInicialLoteLinhaPage> {
        const params: Record<string, any> = {
            page: filter.page ?? 1,
            perPage: filter.perPage ?? 20,
        };
        if (filter.arquivoOperacaoId !== undefined) params.arquivoOperacaoId = filter.arquivoOperacaoId;
        if (filter.importada !== undefined) params.importada = filter.importada;
        if (filter.conta) params.conta = filter.conta;
        if (filter.nomeArquivoOrigem) params.nomeArquivoOrigem = filter.nomeArquivoOrigem;

        const { data } = await api.get<ISaldoInicialLoteLinhaPage>(
            `SaldoInicialLote/esteira/${esteiraId}/linhas`,
            { params }
        );
        return data;
    }

    async obterResumo(arquivoOperacaoId: number): Promise<ISaldoInicialLoteResumo> {
        const { data } = await api.get<ISaldoInicialLoteResumo>(`SaldoInicialLote/arquivo/${arquivoOperacaoId}/resumo`);
        return data;
    }
}

export default new SaldoInicialLoteService();
